import { render, staticRenderFns } from "./RecommendWarningErrors.vue?vue&type=template&id=527b373a&scoped=true"
import script from "./RecommendWarningErrors.vue?vue&type=script&setup=true&lang=ts"
export * from "./RecommendWarningErrors.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RecommendWarningErrors.vue?vue&type=style&index=0&id=527b373a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527b373a",
  null
  
)

export default component.exports